import React, { useState } from "react";

import "./styles.less";
import { useTranslation } from "react-i18next";
import { useInterval } from "react-use";
import { Title } from "../../components/NewTitle";

export const AboutusFuture = () => {
  const { t } = useTranslation();
  const [element, setElement] = useState(1);
  const bannerPic = [
    {
      title: t("aboutus.future.item1.title"),
      subtitle: t("aboutus.future.item1.subtitle"),
      subtitleEn: t("aboutus.future.item1.subtitleEn"),
      url: "//files.authing.co/authing-website/aboutus-future-1.png",
    },
    {
      title: t("aboutus.future.item2.title"),
      subtitle: t("aboutus.future.item2.subtitle"),
      subtitleEn: t("aboutus.future.item2.subtitleEn"),
      url: "//files.authing.co/authing-website/aboutus-future-2.png",
    },
    {
      title: t("aboutus.future.item3.title"),
      subtitle: t("aboutus.future.item3.subtitle"),
      subtitleEn: t("aboutus.future.item3.subtitleEn"),
      url: "//files.authing.co/authing-website/aboutus-future-3.png",
    },
    {
      title: t("aboutus.future.item4.title"),
      subtitle: t("aboutus.future.item4.subtitle"),
      subtitleEn: t("aboutus.future.item4.subtitleEn"),
      url: "//files.authing.co/authing-website/aboutus-future-4.png",
    },
  ];

  const nextFun = () => {
    if (element > 3) {
      setElement(1);
    } else {
      setElement(element + 1);
    }
  };
  const lastFun = () => {
    if (element <= 1) {
      setElement(4);
    } else {
      setElement(element - 1);
    }
  };
  return (
    <div>
      <section>
        <div className="aboutus-future-warp">
          <div className="inner">
            <div className="aboutus-future-title">
              <Title title={t("aboutus.future.title")}></Title>
            </div>

            <div className="aboutus-future-feature">
              <div
                className="last-button"
                onClick={() => {
                  lastFun();
                }}
              >
                <i
                  className="icon authing-icon authing-arrow-down-line"
                  style={{
                    transform: "rotate(-90deg)",
                    display: "inline-block",
                  }}
                ></i>
              </div>
              {bannerPic.map((item, index) => {
                if (element === index + 1) {
                  return (
                    <div className="item-block">
                      <div className="item-bg-img">
                        <img src={item.url} alt="authing" />
                      </div>
                      <div className="item-card-text">
                        <div>
                          <div className="item-card-text-title">
                            {item.title}
                          </div>
                          <div className="item-card-text-subtitle">
                            {item.subtitle}
                          </div>
                          <div className="item-card-text-subtitle-en">
                            {item.subtitleEn}
                          </div>
                        </div>
                      </div>
                    </div>
                  );
                } else {
                  return null;
                }
              })}
              <div
                className="next-button"
                onClick={() => {
                  nextFun();
                }}
              >
                <i
                  className="icon authing-icon authing-arrow-down-line"
                  style={{
                    transform: "rotate(90deg)",
                    display: "inline-block",
                  }}
                ></i>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};
